import { lazyRemoveFavoriteCategory } from 'owa-favorites';
import {
    lazyRemoveFavoritePersona,
    lazyHandleToggleFavoritePersonaError,
} from 'owa-mail-favorites-store';
import type { MailboxInfo } from 'owa-client-types';

export const removeFavoriteCategory = async (
    categoryId: string,
    mailboxInfo: MailboxInfo
): Promise<void> => {
    const removeFavoriteCategoryFunc = await lazyRemoveFavoriteCategory.import();
    removeFavoriteCategoryFunc(categoryId, 'ContextCategory', mailboxInfo);
};

export const removeFavoritePersona = (favoriteId: string, mailboxInfo: MailboxInfo): void => {
    lazyRemoveFavoritePersona
        .importAndExecute(favoriteId, 'ContextPersona', mailboxInfo)
        .catch(() => lazyHandleToggleFavoritePersonaError.importAndExecute(true));
};
